// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * Report utilities
 */

!(function() {
  var CONSTANTS = require('logic/data/Izenda.ReportPartChartConstants');
  var fetcher = require('fetchers/Izenda.ReportsDataFetcher');
  const { contains, filter, isEmpty, isNil, get, placeholder } = require('lodash/fp');

  /**
   * Get dirty report part elements.
   * This method is used for trackable.
   */
  var dirtyReportPartElementField = function(elements) {
    var dirtyElements = placeholder(elements)
      .chain()
      .flatMap(function(item) {
        return item.elements ? item.elements.peek() : [];
      })
      .filter(function(element) {
        return element.checkDirty && element.checkDirty();
      })
      .value();

    return dirtyElements;
  };

  /**
   * Return list field has data type countable
   * @param  {[array]} listElement
   * @return {[array]}
   */
  var getCountableElements = function(listElement) {
    return filter(function(item) {
      return contains(item.previewDataType, CONSTANTS.LIST_COUNTABLE_DATA_TYPE);
    }, listElement);
  };

  /**
   * Get list visible field from list container element
   * @return {array} visible fields list
   */
  var getVisibleField = function() {
    return filter('isVisible', this.elements);
  };

  /**
   * Check required filters before export, print of email
   * @return {Promise} Result
   */
  var checkRequiredFilters = function(designerStore, reportId) {
    if (isNil(designerStore)) {
      return fetcher.validateRequiredFilters(reportId);
    }

    return Promise.resolve(isEmpty(get('fieldsStore.reportFilters.emptyVisibleRequiredFilter', designerStore)));
  };

  module.exports = {
    dirtyReportPartElementField: dirtyReportPartElementField,
    getCountableElements: getCountableElements,
    getVisibleField: getVisibleField,
    checkRequiredFilters: checkRequiredFilters
  };
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportUtils.js